import React from 'react'
import { Header } from '../Header'
import { Footer } from '../Footer'
import line from "../../assests/Group 1870 line2.png";
import innovative1 from "../../assests/innovativeimg1.png";
import innovative2 from "../../assests/whatwedo3.png";
import innovatives1 from "../../assests/innovatives1.png";
import innovatives2 from "../../assests/innovatives2.png";
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import {
    FacebookShareButton,
    WhatsappShareButton,
    TwitterShareButton,
} from "react-share";

import CopyToClipboard from "react-copy-to-clipboard";





function Innovative() {
    const [urlToCopy, setURLToCopy] = useState("");

    const handleCopy = () => {
        setURLToCopy("Copied");
    };
    console.log("urlToCopy", urlToCopy);
    useEffect(() => {
        // Set the scroll position when the component mounts
        window.scrollTo(0, 0); // Adjust the '500' value as needed
    }, []);
    return (
        <>
            <Header />
            <section className='innovativebg' style={{ minHeight: '100vh' }}>

            </section>


            <section className='innovativebg1 shadow' style={{ minHeight: '40vh' }}>
                <div className='container p-2'>
                    <div className='row d-flex justify-content-center'>
                        <div className='col-md-6 mt-3  text-center'>
                            <h4 className='fw-bold mb-0 mt-3'>WATER WELLS</h4>
                            <img className="img-fluid" src={line} />
                            <p>
                                People in rural areas of India travel for miles to drink fresh water. Sometimes the
                                only water available is contaminated. The young and the elderly can easily die from waterborne
                                diseases. Water wells can transform the health of entire villages. The full maintenance and
                                upkeep of the well is entrusted to a family who use this opportunity to create a sustainable
                                income source.
                            </p>
                            <div className='d-flex justify-content-between'>
                                <button
                                    type="button"
                                    class="btn btn-danger"
                                    data-bs-toggle="modal"
                                    data-bs-target="#staticBackdropinnovative1"

                                >
                                    Share <i class="fa-solid fa-share"></i>
                                </button>

                                <div className="row ">
                                    <div
                                        class="modal fade"
                                        id="staticBackdropinnovative1"
                                        data-bs-backdrop="static"
                                        data-bs-keyboard="false"
                                        tabindex="-1"
                                        aria-labelledby="staticBackdropLabel"
                                        aria-hidden="true"
                                    >
                                        <div class="modal-dialog modal-dialog-centered modal-sm">
                                            <div class="modal-content">
                                                <div class="modal-header p-3">
                                                    <h5
                                                        class="modal-title fw-bolder"
                                                        id="staticBackdropLabel"
                                                    >
                                                        WATER WELLS
                                                    </h5>
                                                    <button
                                                        type="button"
                                                        class="btn-close border"
                                                        data-bs-dismiss="modal"
                                                        aria-label="Close"
                                                    ></button>
                                                </div>
                                                <div class="modal-body p-4">
                                                    <div className="row d-flex justify-content-center">
                                                        <div className="col-md-12">
                                                            <a href="https://www.facebook.com/login/">
                                                                <FacebookShareButton
                                                                    url={
                                                                        "https://lovewithoutreason.org/InnovativeSolutions"
                                                                    }
                                                                    quote={"LWR"}
                                                                    hashtag="#lovewithoutreason"
                                                                >
                                                                    <i class="fa-brands fa-square-facebook fa-3x m-1 text-primary"></i>
                                                                </FacebookShareButton>
                                                            </a>
                                                            <a href="https://www.whatsapp.com/">
                                                                <WhatsappShareButton
                                                                    url={
                                                                        "https://lovewithoutreason.org/InnovativeSolutions"
                                                                    }
                                                                    quote={"LWR"}
                                                                    hashtag="#lovewithoutreason"
                                                                >
                                                                    <i class="fa-brands fa-square-whatsapp fa-3x m-1 text-success"></i>
                                                                </WhatsappShareButton>
                                                            </a>
                                                            <a href="https://twitter.com/">
                                                                <TwitterShareButton
                                                                    url={
                                                                        "https://lovewithoutreason.org/InnovativeSolutions"
                                                                    }
                                                                    quote={"LWR"}
                                                                    hashtag="#lovewithoutreason"
                                                                >
                                                                    <i class="fa-brands fa-square-x-twitter  fa-3x m-1 text-info"></i>

                                                                </TwitterShareButton>
                                                            </a>
                                                            <CopyToClipboard
                                                                text={"https://lovewithoutreason.org/InnovativeSolutions"}
                                                                onCopy={handleCopy}
                                                            >
                                                                <i
                                                                    className="fa fa-clone fa-3x m-1"
                                                                    style={{ color: "#C3C4C4" }}
                                                                ></i>
                                                            </CopyToClipboard>
                                                            <p
                                                                style={{
                                                                    fontSize: "8px",
                                                                    textAlign: "end",
                                                                }}
                                                            >
                                                                {urlToCopy !== "" ? urlToCopy : ""}
                                                            </p>
                                                            {/* <a href="https://www.instagram.com/">
                                    <i
                                      className="fa-brands fa-square-instagram fa-3x m-1"
                                      style={{ color: "#E4405F" }}
                                    ></i>
                                  </a> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Link to="/Donate"><button className="btn btn-danger ms-3">Donate&nbsp;<i className="fas fa-duotone fa-hand-holding-heart"></i></button></Link>
                            </div>
                        </div>
                        <div className='col-md-6 mt-5'>
                            <img className="img-fluid mt-5" src={innovative1} />

                        </div>
                    </div>
                </div>
            </section>


            <section className='innovativebg1 shadow' style={{ minHeight: '40vh' }}>
                <div className='container p-2'>
                    <div className='row d-flex justify-content-center mt-5'>
                        <div className='col-md-4 mt-5'>
                            <img className="img-fluid" src={innovative2} />

                        </div>
                        <div className='col-md-5  text-center'>
                            <h4 className='fw-bold mb-0  mt-2'>SET FREE PADS</h4>
                            <img className="img-fluid" src={line} />
                            <p>
                                Women who are healthy can care for their families and ensure the health and
                                education of their children. Providing them with reusable sanitary pads that are comfortable
                                and easy to clean empowers their health and in turn impacts their socioeconomic status. The
                                Set Free Pads are designed and sewn by women in vulnerable situations in the red-light districts
                                in India. With the job of producing the Set Free Pads, the women earn a steady income and can
                                send their children to school, potentially preventing them from human trafficking.
                            </p>
                            <div className='d-flex justify-content-between'>
                                <button
                                    type="button"
                                    class="btn btn-danger mb-3"
                                    data-bs-toggle="modal"
                                    data-bs-target="#staticBackdropinnovative2"

                                >
                                    Share <i class="fa-solid fa-share"></i>
                                </button>

                                <div className="row ">
                                    <div
                                        class="modal fade"
                                        id="staticBackdropinnovative2"
                                        data-bs-backdrop="static"
                                        data-bs-keyboard="false"
                                        tabindex="-1"
                                        aria-labelledby="staticBackdropLabel"
                                        aria-hidden="true"
                                    >
                                        <div class="modal-dialog modal-dialog-centered modal-sm">
                                            <div class="modal-content">
                                                <div class="modal-header p-3">
                                                    <h5
                                                        class="modal-title fw-bolder"
                                                        id="staticBackdropLabel"
                                                    >
                                                        SET FREE PADS
                                                    </h5>
                                                    <button
                                                        type="button"
                                                        class="btn-close border"
                                                        data-bs-dismiss="modal"
                                                        aria-label="Close"
                                                    ></button>
                                                </div>
                                                <div class="modal-body p-4">
                                                    <div className="row d-flex justify-content-center">
                                                        <div className="col-md-12">
                                                            <a href="https://www.facebook.com/login/">
                                                                <FacebookShareButton
                                                                    url={
                                                                        "https://lovewithoutreason.org/InnovativeSolutions"
                                                                    }
                                                                    quote={"LWR"}
                                                                    hashtag="#lovewithoutreason"
                                                                >
                                                                    <i class="fa-brands fa-square-facebook fa-3x m-1 text-primary"></i>
                                                                </FacebookShareButton>
                                                            </a>
                                                            <a href="https://www.whatsapp.com/">
                                                                <WhatsappShareButton
                                                                    url={
                                                                        "https://lovewithoutreason.org/InnovativeSolutions"
                                                                    }
                                                                    quote={"LWR"}
                                                                    hashtag="#lovewithoutreason"
                                                                >
                                                                    <i class="fa-brands fa-square-whatsapp fa-3x m-1 text-success"></i>
                                                                </WhatsappShareButton>
                                                            </a>
                                                            <a href="https://twitter.com/">
                                                                <TwitterShareButton
                                                                    url={
                                                                        "https://lovewithoutreason.org/InnovativeSolutions"
                                                                    }
                                                                    quote={"LWR"}
                                                                    hashtag="#lovewithoutreason"
                                                                >
                                                                    <i class="fa-brands fa-square-x-twitter  fa-3x m-1 text-info"></i>

                                                                </TwitterShareButton>
                                                            </a>
                                                            <CopyToClipboard
                                                                text={"https://lovewithoutreason.org/InnovativeSolutions"}
                                                                onCopy={handleCopy}
                                                            >
                                                                <i
                                                                    className="fa fa-clone fa-3x m-1"
                                                                    style={{ color: "#C3C4C4" }}
                                                                ></i>
                                                            </CopyToClipboard>
                                                            <p
                                                                style={{
                                                                    fontSize: "8px",
                                                                    textAlign: "end",
                                                                }}
                                                            >
                                                                {urlToCopy !== "" ? urlToCopy : ""}
                                                            </p>
                                                            {/* <a href="https://www.instagram.com/">
                                    <i
                                      className="fa-brands fa-square-instagram fa-3x m-1"
                                      style={{ color: "#E4405F" }}
                                    ></i>
                                  </a> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Link to="/Donate"><button className="btn btn-danger mb-3">Donate&nbsp;<i className="fas fa-duotone fa-hand-holding-heart"></i></button></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className='shadow mb-2' style={{ minHeight: '100vh' }}>
                <div className='container'>
                    <div className="row d-flex justify-content-center">
                        <div className="col-md-12 text-center mt-3">
                            <h4 class="text-dark fw-bold mb-0 text-uppercase">Awareness and Leadership Training</h4>
                            <img className="img-fluid" src={line} alt='image' />
                        </div>
                    </div>

                    <div className='row '>
                        <div className='col-md-12 text-center '>
                            <p className="px-5">
                                Education is the single most important factor in
                                eradicating human trafficking. Every opportunity to raise awareness of this evil crime is taken
                                during the medical camps and during Love Without Reason events. Our volunteers and
                                counselors empower and educate the parents and children during the medical camps with
                                information about human trafficking. Our efforts include sharing contact information of local
                                authorities to whom our families may report suspicious activities.
                            </p>
                        </div>
                    </div>


                    <div className='row d-flex justify-content-center'>
                        <div className='col-md-6 text-center mt-5'>
                            <img className="img-fluid" src={innovatives1} />

                            <p className='mt-5'>
                                People, Not Products is a one-day seminar featuring speakers on local, national and
                                international levels to educate on cybersecurity, internet safety, addiction and human
                                trafficking.<br /><br />


                            </p>
                        </div>
                        <div className='col-md-6 text-center mt-5 '>
                            <img className="img-fluid" src={innovatives2} />

                            <p className='mt-5'>

                                Leadership training is shared in community civic groups and in churches to raise leaders with
                                integrity and dedication in serving their people. This training is led by our partners including
                                schools, churches and business corporations.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />


        </>
    )
}

export default Innovative
